/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseContentPageContentBlocksInner } from './DatabaseContentPageContentBlocksInner';
import {
    DatabaseContentPageContentBlocksInnerFromJSON,
    DatabaseContentPageContentBlocksInnerFromJSONTyped,
    DatabaseContentPageContentBlocksInnerToJSON,
} from './DatabaseContentPageContentBlocksInner';
import type { DatabaseContentPageTransitionOptions } from './DatabaseContentPageTransitionOptions';
import {
    DatabaseContentPageTransitionOptionsFromJSON,
    DatabaseContentPageTransitionOptionsFromJSONTyped,
    DatabaseContentPageTransitionOptionsToJSON,
} from './DatabaseContentPageTransitionOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabasePageSizeMode } from './DatabasePageSizeMode';
import {
    DatabasePageSizeModeFromJSON,
    DatabasePageSizeModeFromJSONTyped,
    DatabasePageSizeModeToJSON,
} from './DatabasePageSizeMode';

/**
 * 
 * @export
 * @interface DatabaseContentPage
 */
export interface DatabaseContentPage {
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    ctaCaption?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    locked?: boolean;
    /**
     * 
     * @type {DatabaseContentPageTransitionOptions}
     * @memberof DatabaseContentPage
     */
    transitionOptions?: DatabaseContentPageTransitionOptions;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    inlineStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    backgroundColor?: string;
    /**
     * 
     * @type {DatabasePageSizeMode}
     * @memberof DatabaseContentPage
     */
    sizeMode?: DatabasePageSizeMode;
    /**
     * 
     * @type {number}
     * @memberof DatabaseContentPage
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseContentPage
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    aspectRatio?: string;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabaseContentPage
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
    /**
     * 
     * @type {Array<DatabaseContentPageContentBlocksInner>}
     * @memberof DatabaseContentPage
     */
    contentBlocks?: Array<DatabaseContentPageContentBlocksInner>;
}

/**
 * Check if a given object implements the DatabaseContentPage interface.
 */
export function instanceOfDatabaseContentPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseContentPageFromJSON(json: any): DatabaseContentPage {
    return DatabaseContentPageFromJSONTyped(json, false);
}

export function DatabaseContentPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseContentPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ctaCaption': !exists(json, 'ctaCaption') ? undefined : json['ctaCaption'],
        'locked': !exists(json, 'locked') ? undefined : json['locked'],
        'transitionOptions': !exists(json, 'transitionOptions') ? undefined : DatabaseContentPageTransitionOptionsFromJSON(json['transitionOptions']),
        'inlineStyle': !exists(json, 'inlineStyle') ? undefined : json['inlineStyle'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'sizeMode': !exists(json, 'sizeMode') ? undefined : DatabasePageSizeModeFromJSON(json['sizeMode']),
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'aspectRatio': !exists(json, 'aspectRatio') ? undefined : json['aspectRatio'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
        'contentBlocks': !exists(json, 'contentBlocks') ? undefined : ((json['contentBlocks'] as Array<any>).map(DatabaseContentPageContentBlocksInnerFromJSON)),
    };
}

export function DatabaseContentPageToJSON(value?: DatabaseContentPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
        'ctaCaption': value.ctaCaption,
        'locked': value.locked,
        'transitionOptions': DatabaseContentPageTransitionOptionsToJSON(value.transitionOptions),
        'inlineStyle': value.inlineStyle,
        'backgroundColor': value.backgroundColor,
        'sizeMode': DatabasePageSizeModeToJSON(value.sizeMode),
        'width': value.width,
        'height': value.height,
        'aspectRatio': value.aspectRatio,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
        'contentBlocks': value.contentBlocks === undefined ? undefined : ((value.contentBlocks as Array<any>).map(DatabaseContentPageContentBlocksInnerToJSON)),
    };
}

